import React from 'react';

const Capitalize = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.289 8.549L5.628 13H8.951L7.289 8.549ZM12.58 17H10.445L9.698 15H4.881L4.134 17H2L6.106 6H8.472L12.58 17ZM15.5309 16.9467C16.0137 17.1822 16.5734 17.3 17.2099 17.3C17.8134 17.3 18.3567 17.1878 18.8395 16.9635C19.3224 16.7392 19.7174 16.4308 20.0247 16.0383V17.0308H22V11.8327C22 11.0813 21.8299 10.4477 21.4897 9.93176C21.1495 9.40466 20.6722 9.00092 20.0576 8.72055C19.454 8.44017 18.7462 8.29999 17.9342 8.29999C17.1989 8.29999 16.5185 8.42896 15.893 8.6869C15.2675 8.93363 14.7353 9.2813 14.2963 9.72989L15.4321 11.0757C15.7394 10.7505 16.096 10.4925 16.5021 10.3019C16.9081 10.1112 17.3525 10.0159 17.8354 10.0159C18.4499 10.0159 18.9438 10.1673 19.3169 10.4701C19.69 10.7729 19.893 11.1991 19.9259 11.7486H18.0165C16.7984 11.7486 15.8217 11.9953 15.0864 12.4888C14.3621 12.9822 14 13.6607 14 14.5243C14 15.0738 14.1317 15.5561 14.3951 15.971C14.6694 16.386 15.048 16.7112 15.5309 16.9467ZM19.0535 15.2645C18.6584 15.5112 18.214 15.6346 17.7202 15.6346C17.2702 15.6346 16.9026 15.528 16.6173 15.3149C16.3429 15.0906 16.2058 14.7991 16.2058 14.4402C16.2058 14.0364 16.3868 13.728 16.749 13.5149C17.1111 13.3019 17.5885 13.1953 18.1811 13.1953H19.9259V14.2719C19.7394 14.6869 19.4486 15.0177 19.0535 15.2645Z"
      fill="currentColor"
    />
  </svg>
);

export default Capitalize;
